import { ActionType, EntityType, ModuleType } from "../../../queryKeyFactory";
export const serviceAreaKeyFactory = {
  TerritoryView: (): [ModuleType, EntityType] => [
    "onboarding",
    "TerritoryView",
  ],
  EntityTypes: (): [ModuleType, EntityType] => [
    "onboarding",
    "EntityTypes",
  ],
    Count: (): [ModuleType, EntityType] => [
    "onboarding",
    "territoryCount",
  ],
  TerritoryStats: (): [ModuleType, EntityType] => [
    "onboarding",
    "TerritoryStats",
  ],
EntityTypeNonPaginated: (level?: string): [ModuleType, EntityType, string?] => [
  "onboarding",
  "EntityTypeNonPaginated",
  level
],
    UserNames: (): [ModuleType, EntityType] => [
    "onboarding",
    "UserNames",
  ],
  // territoryMapping: (
  //   page: number,
  //   limit: number,
  //   territoryCode?: string
  // ): [ModuleType, EntityType, number, number, string] => [
  //     "onboarding",
  //     "territoryMapping",
  //     page,
  //     limit,
  //     territoryCode,
  //   ],
  // Update your QueryKeyFactory
territoryMapping: (params: {
  page: number;
  limit: number;
  territoryCode?: string;
  searchData?: string;
  isPaginationRequired?: string;
  territoryType?: string;
  status?: boolean;
  createdOn?: string;
  search_data?: string;
}): unknown[] => [
  "onboarding",
  "territoryMapping",
  params.page,
  params.limit,
  params.territoryCode,
  params.searchData,
  params.isPaginationRequired,
  params.territoryType,
  params.status,
  params.createdOn,
  params.searchData,
],

  territoryPremiseStats: (
  remoteUtilityId: string,
  territoryCode: string
): [ModuleType, EntityType, string, string] => [
  "onboarding",
  "territory-premise-stats",
  remoteUtilityId,
  territoryCode,
],
monthlySummary: (remoteUtilityId: string): [ModuleType, EntityType, string] => [
  "onboarding",
  "monthlySummary",
  remoteUtilityId,
],



  territoryJson: (
    remoteUtilityId: string,
    configLevel: string
  ): [ModuleType, EntityType, string, string] => [
      "onboarding",
      "territoryJson",
      remoteUtilityId,
      configLevel,
    ],

  configCode: (entityName: string): [ModuleType, EntityType, string] => [
    "onboarding",
    "configCode",
    entityName,
  ],
};
